import { KeycloakInitOptions } from 'keycloak-js';

export const configApi = (window as Record<string, any>).appConfig;

export const keycloakInit: KeycloakInitOptions = {
    redirectUri: `${window.location.origin}${
        window.location.pathname !== '/login' ? window.location.pathname + window.location.search : '/dashboard'
    }`,
    onLoad: 'login-required',
    enableLogging: false
};

export const BASE_PATH = '';

export const DASHBOARD_PATH = '/dashboard';

export const HORIZONTAL_MAX_ITEM = 6;
